import type { AdvertisingFreshness, DataSource } from '@/api/types'
import { TooltipBadge } from '@/components/TooltipBadge'
import { FreshnessBadge } from '@/design'

import { attributionWindowsLabel } from './metrics'

const CAVEAT =
  'These figures are reported by Meta, not counted by Competition Insights. Meta attributes purchases and revenue by its own rules, so they will not match your order records exactly.'

/** The provenance every number on this page carries — the same shape as the Traffic page's own badge. */
export function SourceBadge() {
  return <TooltipBadge tone="info" label="Source: Meta" tooltip={CAVEAT} className="adv-source" />
}

/** The badge on Purchases, Revenue and ROAS: Meta's own attribution, never TmT's. */
export function ProviderAttributedBadge({ attributionWindows }: { attributionWindows: readonly string[] }) {
  const tooltip = `Meta's own attribution window: ${attributionWindowsLabel(attributionWindows)}.`
  return <TooltipBadge tone="accent" label="Provider-attributed" tooltip={tooltip} className="adv-provider-badge" />
}

export function AdvertisingFreshnessBadge({ freshness, source }: { freshness: AdvertisingFreshness; source: DataSource }) {
  return (
    <span className="adv-freshness">
      <FreshnessBadge meta={{ source, lastUpdatedAt: freshness.generatedAt }} />
      {freshness.providerLag ? (
        <p role="status" className="adv-note">
          <strong>Provider data is delayed.</strong> Meta spend has not refreshed as often as it should, so
          today&rsquo;s figures may be behind. The next import picks it up.
        </p>
      ) : null}
    </span>
  )
}
